import React, { useState, useEffect } from 'react';
import { Comment, Avatar, Form, Button, List, Input } from 'antd';
import { useDispatch } from 'react-redux';
import api from '../../Api/api';
import { REQUEST_GET_PROJECT_DATA } from '../../Redux/constants/constants';

const { TextArea } = Input;

const CommentList = ({ comments }) => (
  <List
    dataSource={comments}
    header={`${comments.length} ${comments.length > 1 ? 'notes' : 'note'}`}
    itemLayout="horizontal"
    renderItem={(props) => <Comment {...props} />}
  />
);

const Editor = ({ onChange, onSubmit, submitting, value }) => (
  <div>
    <Form.Item>
      <TextArea rows={4} onChange={onChange} value={value} />
    </Form.Item>
    <Form.Item>
      <Button htmlType="submit" loading={submitting} onClick={onSubmit}>
        Dodaj notatkę
      </Button>
    </Form.Item>
  </div>
);

const ProjectNotes = ({ notes, projectId }) => {
  const [comments, setComments] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [value, setValue] = useState('');
  const dispatch = useDispatch();

  let localComments = [];
  if (notes) {
    localComments = notes.map((note) => ({
      author: <p>{note.user.name}</p>,
      avatar: <Avatar icon="user" />,
      content: <p>{note.note}</p>,
      datetime: <p>{note.createdAt.slice(0, 10)}</p>,
    }));
  }
  useEffect(() => {
    setComments([...localComments]);
  }, [notes]);

  const handleSubmit = () => {
    if (!value) {
      return;
    }
    setSubmitting(true);
    api
      .postProjectNote({ note: value, projectId })
      .then((res) => {
        setSubmitting(false);
        setValue('');
        dispatch({
          type: REQUEST_GET_PROJECT_DATA,
          payload: res.data.projectId,
        });
      })
      .catch(() => {
        setSubmitting(false);
        console.log('some error during save');
      });
  };

  const handleChange = (e) => setValue(e.target.value);

  return (
    <>
      <Comment
        avatar={<Avatar icon="user" />}
        content={
          <Editor
            onChange={handleChange}
            onSubmit={handleSubmit}
            submitting={submitting}
            value={value}
          />
        }
      />
      {comments.length > 0 && <CommentList comments={comments} />}
    </>
  );
};

export default ProjectNotes;
